<template>
  <v-card class="com-mb-card rw-twn">
    <v-col class="com-mb-card-contents-none-border pa-0">
      <v-col class="com-mb-card-title px-0 pt-2 pb-0 ma-0">
        <span class="com-mb-card-title pl-2">関連市町村</span>
      </v-col>
    </v-col>
    <v-col class="com-mb-card-contents-none-border rw-box-link pa-0">
      <div class="pa-0" v-if="selectedRwDetailMt">
        <span
          v-for="(pref, prefIdx) in selectedRwDetailMt.prefTwn"
          :key="'prefIdx' + prefIdx"
        >
          <v-btn
            class="rw-text-pref py-0 pl-2"
            small
            text
            @click="setPrefCd(pref.prefCd)"
            >【{{ pref.prefNm }}】</v-btn
          >
          <v-row class="ma-0 pl-2 pb-1">
            <span
              v-for="(town, townIdx) in pref.twn"
              :key="'prefIdx' + prefIdx + 'townIdx' + townIdx"
            >
              <v-btn
                class="py-0 px-1 pl-2"
                text
                small
                @click="setTwnCd(town.twnCd)"
                >{{ town.twnNm }}</v-btn
              >
            </span>
          </v-row>
        </span>
      </div>
    </v-col>
  </v-card>
</template>

<script>
export default {
  name: "rw-twn",
  computed: {
    /**
     * 選択中予警報種別
     */
    selectedWarnType: {
      get() {
        return this.$store.state.RiverWarn.selectedWarnType;
      },
    },
    /**
     * 選択中河川予警報マスタ
     */
    selectedRwDetailMt: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.mt;
      },
    },
  },
  methods: {
    /** 都道府県選択時 */
    setPrefCd(prefCd) {
      this.$log.debug("[Riverwarn] setPrefCd(" + prefCd + ")");
      this.$store.dispatch("map/moveMapPrefecture", Number(prefCd));
    },
    /** 市町村選択時 */
    setTwnCd(twnCd) {
      this.$log.debug("[Riverwarn] setTwnCd(" + twnCd + ")");
      this.$store.dispatch("map/moveMapCity", Number(twnCd));
    },
  },
};
</script>

<style lang="scss" scoped>
.rw-twn {
  width: 100%;

  .rw-header {
    display: flex;
    align-items: center;
  }

  .rw-box-link {
    .rw-text-pref {
      font-size: 0.75rem;
    }
  }
}
</style>
